import { render, staticRenderFns } from "./CallDetailIncoming.vue?vue&type=template&id=61410628&"
import script from "./CallDetailIncoming.vue?vue&type=script&lang=ts&"
export * from "./CallDetailIncoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports